module.exports = __webpack_public_path__ + "static/media/quickbooks.ec61f5b6.svg";